import { StylesComponent } from './styles.js';

customElements.define('awml-styles', StylesComponent);
